import { FC } from 'react';
import HeaderItem from '../headerItem/HeaderItem';
import type { HeaderItemsPropsTypes } from './types/propsTypes';
import styles from './HeaderItems.module.scss';

const HeaderItems: FC<HeaderItemsPropsTypes> = ({ HeaderItemsData }) => (
  <span className={styles['side-navigation-container']}>
    <ul className={styles['side-navigation-item-list']} data-testid="headerItems-test-id">
      {HeaderItemsData.map((item) => (
        <HeaderItem key={item.id} {...item} />
      ))}
    </ul>
  </span>
);
export default HeaderItems;
